export default __webpack_public_path__ + "a5942eab2407c918b44b9f23c43272e8.svg";